import { useAppStore } from "@/store"
import { computed, defineComponent } from "vue"
import { useRoute, useRouter } from "vue-router"
import styles from "./index.module.less"

export default defineComponent({
  name: "SwitchMenu",
  props: {
    menus: { type: Array, default: () => [] },
    beforeNavigate: Function
  },
  emits: ["beforeNavigate"],
  setup(props, { emit }) {
    const appStore = useAppStore()
    const route = useRoute()
    const router = useRouter()

    const selectedMenuPath = computed(() => {
      const { path } = route
      const menu = props.menus.find((menu) => menu.path === path)
      if (menu) return menu.path
      else return false
    })
    const renderMenuItem = () => {
      return props.menus.map((menu) => {
        const { name, path } = menu
        const isSelected = selectedMenuPath.value === path
        const classNames = [
          "w-0p grow-1",
          styles.switchMenuItem,
          { [styles.selectedMenu]: isSelected },
          { [styles.elder]: appStore.isElder }
        ]

        if (menu.icon) {
          classNames.push(styles.iconMenuItem)
        }
        const renderImg = () => {
          const { icon, selected } = menu

          if (isSelected) {
            if (selected)
              return (
                <svg class={["iconfont-svg", styles.icon]} aria-hidden="true">
                  <use xlink:href={selected}></use>
                </svg>
              )
          } else {
            if (icon)
              return (
                <svg class={["iconfont-svg", styles.icon]} aria-hidden="true">
                  <use xlink:href={icon}></use>
                </svg>
              )
          }
        }
        const switchMenu = () => {
          const res = props.beforeNavigate ? props.beforeNavigate(menu) : true
          if (res !== false) router.replace({ path })
        }
        return (
          <div class={classNames} onClick={switchMenu}>
            {renderImg()}
            {name}
          </div>
        )
      })
    }

    const MenuClassNames = ["flex--a-c", styles.switchMenu]
    return () => {
      if (selectedMenuPath.value) {
        return <div class={MenuClassNames}>{renderMenuItem()}</div>
      } else return null
    }
  }
})
